/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react';
import {refreshTokenOrRedirect} from '../api/HttpUtils'

class Timer extends React.Component {
    constructor(props) {
        super(props)

        this.userDetailsTimer = null;

        this.userDetailsTimeout = 60000

    }

    componentDidMount() {
        const me = this
        this.userDetailsTimer = setInterval(function() {
            me.refreshToken()
        }, this.userDetailsTimeout);
    }

    componentWillUnmount() {
        clearInterval(this.userDetailsTimer);
    }

    refreshToken() {
        refreshTokenOrRedirect()
    }

    render() {
        return null
    }
}

export default (Timer)
